import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from '@/store/features/baseRtkQuery';
import type {
    ChannelHealthResponse,
    OpsPlatformFilter,
} from '@/app/ops/dashboards/channels/health/types';

export type GetChannelHealthParams = {
    platform?: OpsPlatformFilter;
    from?: string | null;
    to?: string | null;
    detailLimit?: number;
    /** Aggregate the preceding window of equal length too, for period-over-period deltas. */
    comparePrevious?: boolean;
    /** `day`, `hour`, or `week`. */
    granularity?: 'day' | 'hour' | 'week' | 'month';
};

export const opsChannelHealthApiSlice = createApi({
    reducerPath: 'opsChannelHealthApi',
    baseQuery: baseQueryWithReAuth,
    tagTypes: ['ChannelHealth'],
    endpoints: (builder) => ({
        getChannelHealth: builder.query<ChannelHealthResponse, GetChannelHealthParams | void>({
            query: (params) => {
                const search = new URLSearchParams();
                const platform = params?.platform ?? 'all';
                search.set('platform', platform);
                if (params?.from) search.set('from', params.from);
                if (params?.to) search.set('to', params.to);
                if (params?.detailLimit) search.set('detailLimit', String(params.detailLimit));
                if (params?.comparePrevious === false) search.set('comparePrevious', 'false');
                if (params?.granularity) search.set('granularity', params.granularity);
                return {
                    url: `api/ops/channels/health?${search.toString()}`,
                    method: 'GET',
                };
            },
            providesTags: ['ChannelHealth'],
        }),
    }),
});

export const opsChannelHealthApiActions = {
    useGetChannelHealthQuery: opsChannelHealthApiSlice.useGetChannelHealthQuery,
};
